import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import PageShell from '../components/ui/PageShell'
import Card from '../components/ui/Card'
import SectionTitle from '../components/ui/SectionTitle'

const linkClass = 'text-[#00d4aa] hover:underline'

export default function AGB() {
  const location = useLocation()
  const isDashboard = location.pathname.startsWith('/dashboard')
  return (
    <PageShell>
      <div className="max-w-3xl space-y-6">
        <SectionTitle title="Allgemeine Geschäftsbedingungen" />
        <Card className="p-6 space-y-6 text-sm text-white/90">
          <p className="text-white/70">
            Gültig für den Online-Dienst „AI Mastering Studio“ (mastering.anwendungen.online) der Marc Fischer Digital Solution
            NRW.
          </p>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">§&nbsp;1 Geltungsbereich</h2>
            <p>
              Diese AGB gelten für alle Verträge zwischen Marc Fischer Digital Solution NRW, Inhaber Marc Fischer, Lärchenweg 9,
              50389 Wesseling (nachfolgend „Anbieter“) und Nutzern des Dienstes AI Mastering Studio (nachfolgend „Kunde“) über
              die Nutzung der Plattform sowie den Erwerb von Credits und damit verbundenen Leistungen.
            </p>
            <p className="mt-2">
              Abweichende Bedingungen des Kunden werden nur Vertragsbestandteil, wenn der Anbieter schriftlich zustimmt.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">§&nbsp;2 Vertragsschluss</h2>
            <p>
              Die Registrierung eines Nutzerkontos und die Nutzung des Dienstes erfolgen nach Maßgabe dieser AGB und der{' '}
              <Link to={isDashboard ? '/dashboard/nutzungsbedingungen' : '/nutzungsbedingungen'} className={linkClass}>
                Nutzungsbedingungen
              </Link>
              . Der Kauf von Credits stellt ein verbindliches Angebot des Kunden dar; der Vertrag kommt mit erfolgreicher
              Zahlungsbestätigung (z.&nbsp;B. über Stripe) bzw. Gutschrift der Credits zustande.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">§&nbsp;3 Leistungsumfang</h2>
            <p>
              Der Anbieter stellt eine webbasierte Plattform zur KI-/algorithmengestützten Audio-Mastering-Verarbeitung bereit.
              Art und Umfang der einzelnen Jobs ergeben sich aus der jeweiligen Funktionsbeschreibung im Dienst. Credits werden
              gemäß der jeweils angezeigten Pakete und Preise erworben und für Jobs (sowie ggf. Zusatzfunktionen wie Cover)
              verbraucht.
            </p>
            <p className="mt-2">
              Der Anbieter erbringt die Leistung nach dem jeweiligen Stand der Technik. Absolute Übereinstimmung mit
              subjektiven Hörerwartungen oder mit Ergebnissen Dritter kann nicht zugesichert werden. Qualitätskennwerte
              (z.&nbsp;B. LUFS) können als Orientierung ausgewiesen werden; Abweichungen begründen keinen Mangel, soweit die
              Verarbeitung technisch erfolgreich abgeschlossen wurde.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">§&nbsp;4 Credits, Preise und Zahlung</h2>
            <p>
              Es gelten die im Dienst angezeigten Preise inklusive der gesetzlichen Umsatzsteuer, soweit ausgewiesen. Zahlung
              erfolgt über den eingebundenen Zahlungsdienstleister (Stripe). Credits sind an das Nutzerkonto gebunden, nicht
              übertragbar und – soweit nicht zwingend gesetzlich anders vorgeschrieben – nicht auszahlbar.
            </p>
            <p className="mt-2">
              Bereits verbrauchte Credits für abgeschlossene oder gestartete Jobs werden grundsätzlich nicht erstattet. Bei
              technischem Totalausfall eines Jobs aus Verantwortung des Anbieters kann der Anbieter nach eigenem Ermessen
              Credits gutschreiben oder den Job erneut ausführen.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">§&nbsp;5 Widerrufsbelehrung (Verbraucher)</h2>
            <p>
              Verbrauchern steht ein gesetzliches Widerrufsrecht zu. Bei digitalen Inhalten / Dienstleistungen, die vor Ablauf
              der Widerrufsfrist vollständig erbracht werden bzw. deren Ausführung mit ausdrücklicher Zustimmung des
              Verbrauchers und Kenntnisnahme des Erlöschens des Widerrufsrechts begonnen wird (z.&nbsp;B. sofort nutzbare
              Credits und Mastering-Jobs), kann das Widerrufsrecht erlöschen (§&nbsp;356 Abs.&nbsp;4 / §&nbsp;356 Abs.&nbsp;5
              BGB). Details und Muster-Widerrufsformular auf Anfrage per E-Mail.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">§&nbsp;6 Mitwirkungspflichten</h2>
            <p>
              Der Kunde stellt rechtmäßige Audiodateien bereit, für die er die erforderlichen Rechte besitzt, und hält
              Zugangsdaten geheim. Verzögerungen oder Fehler durch ungeeignete Dateien, fehlende Rechte oder falsche Angaben
              gehen zulasten des Kunden.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">§&nbsp;7 Nutzungsrechte an Ergebnissen</h2>
            <p>
              An den vom Dienst erzeugten Mastering-Ergebnissen erhält der Kunde nach erfolgreicher Bereitstellung ein
              einfaches, zeitlich unbegrenztes Nutzungsrecht für den vertraglich vorgesehenen Zweck (eigene Auswertung /
              Veröffentlichung seiner Werke), soweit er die erforderlichen Rechte an dem Ausgangsmaterial besitzt. Die
              Plattform-Software, Algorithmen und Marken verbleiben beim Anbieter bzw. den jeweiligen Rechteinhabern.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">§&nbsp;8 Vertraulichkeit und Datenschutz</h2>
            <p>
              Personenbezogene Daten werden gemäß der{' '}
              <Link to={isDashboard ? '/dashboard/datenschutz' : '/datenschutz'} className={linkClass}>
                Datenschutzerklärung
              </Link>{' '}
              verarbeitet. Audioinhalte werden zur Vertragserfüllung verarbeitet und nicht zu Trainingszwecken Dritter freigegeben,
              soweit nicht gesondert und transparent vereinbart.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">§&nbsp;9 Verfügbarkeit</h2>
            <p>
              Der Anbieter bemüht sich um eine hohe Verfügbarkeit, schuldet jedoch keine ununterbrochene Verfügbarkeit.
              Wartung, Updates und höhere Gewalt können zu Unterbrechungen führen.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">§&nbsp;10 Haftung</h2>
            <p>
              Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung von Leben, Körper oder
              Gesundheit. Bei leichter Fahrlässigkeit nur bei Verletzung wesentlicher Vertragspflichten und begrenzt auf den
              vertragstypischen, vorhersehbaren Schaden. Haftung für mittelbare Schäden, entgangenen Gewinn und Datenverlust
              ist – soweit gesetzlich zulässig – ausgeschlossen, es sei denn, Vorsatz oder grobe Fahrlässigkeit liegen vor.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">§&nbsp;11 Kündigung / Konto</h2>
            <p>
              Der Kunde kann das Konto jederzeit löschen. Der Anbieter kann Konten bei Verstößen gegen diese AGB oder die
              Nutzungsbedingungen sperren oder kündigen. Nicht verbrauchte Credits verfallen bei Kontolöschung, soweit nicht
              zwingend etwas anderes gilt.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">§&nbsp;12 Schlussbestimmungen</h2>
            <p>
              Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Gegenüber Verbrauchern
              bleiben zwingende Verbraucherschutzvorschriften des Wohnsitzstaates unberührt. Ist der Kunde Kaufmann,
              juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen, ist Gerichtsstand der Sitz
              des Anbieters.
            </p>
            <p className="mt-2">Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen unberührt.</p>
            <p className="mt-2 text-white/50 text-xs">Stand: August 2026</p>
          </section>
        </Card>
        <p className="text-center">
          <Link to={isDashboard ? '/dashboard' : '/'} className={linkClass}>
            ← {isDashboard ? 'Zum Dashboard' : 'Zur Startseite'}
          </Link>
        </p>
      </div>
    </PageShell>
  )
}
